import { Dropdown, Collapse } from 'bootstrap'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('bootstrap', { Dropdown, Collapse })
})
